import { Helmet } from 'react-helmet-async';

const ContactHelmet = () => (
  <Helmet key={'Liên hệ' || 'Thành Đồng Group'}>
    <title>Liên hệ | Thành Đồng Group</title>
    <meta
      name="description"
      content="Liên hệ với Công ty TNHH XD TMDV Thành Đồng để được tư vấn các dịch vụ vệ sinh công nghiệp, giúp việc nhà, chống thấm tại Cần Thơ."
    />
    <meta name="robots" content="index, follow" />
    <meta name="author" content="Thành Đồng Group" />
    <meta
      name="keywords"
      content="liên hệ, tư vấn dịch vụ, công ty thành đồng, cần thơ"
    />

    <meta property="og:type" content="website" />
    <meta property="og:title" content="Liên hệ | Thành Đồng Group" />
    <meta
      property="og:description"
      content="Liên hệ để được báo giá và tư vấn các dịch vụ vệ sinh công nghiệp và chống thấm tại Cần Thơ."
    />
    <meta property="og:url" content="https://thanhdongct.com/lien-he" />
    <meta property="og:image" content="https://thanhdongct.com/images/logo_thanh_dong.png" />

    <link rel="canonical" href="https://thanhdongct.com/lien-he" />
  </Helmet>
);

export default ContactHelmet;
